import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteRoadmapItem($id: ID!) {
        deleteRoadmapItem(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
